// extracted by mini-css-extract-plugin
module.exports = {"container":"page-not-found_container__ZU1sF","fade-in":"page-not-found_fade-in__owQ2J"};